import React from 'react';
import Navigation from '../navigation';
import ImageUploader from '../image-uploader';
import Card from './card';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

export default class Posts extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title: '',
            content: EditorState.createEmpty(),
            pageState: 'normal',
            featureImgUrl: null,
            uploadInProgress: false,
        };
    }

    componentDidMount() {
        if (!this.props.account.email) {
            this.props.getAccount();
        }
        if (this.props.posts === null) {
            this.props.getPosts();
        }
    }

    _hasLikedPost(likes) {
        const { account } = this.props;
        return Boolean(likes.find(like => like.user === account._id));
    }

    _getPostLike(likes) {
        const { account } = this.props;
        const like = likes.find(like => like.user === account._id);
        return like._id;
    }

    handleSubmit() {
        const { title, content } = this.state;
        if (title !== '' && typeof(content) === 'string' && content !== '') {
            this.props.createPost(this.state);
            this.setState({ pageState: 'normal' });
        }
    }

    updateFeatureImg(url) {
        this.setState({ featureImgUrl: url, uploadInProgress: false });
    }

    /**
     * Convert HTML to Draft.js EditorState instance
     * @param  {String} html The HTML
     * @return {Object} Draft.js EditorState instance
     */
    _htmlToDraft(html) {
        const blocksFromHtml = htmlToDraft(html);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        return EditorState.createWithContent(contentState);
    }

    /**
     * Convert Draft.js EditorState instance to HTML
     * @param  {Object} state Draft.js EditorState instance
     * @return {String} Converted HTML
     */
    _draftToHtml(state) {
        const rawContentState = convertToRaw(state.getCurrentContent());
        return draftToHtml(rawContentState);
    }

    onEditorStateChange(editorState) {
        this.setState({ content: this._draftToHtml(editorState) });
    }

    render() {
        const { posts } = this.props;
        const { pageState, uploadInProgress, featureImgUrl, content } = this.state;
        return (
            <div>
                <Navigation {...this.props} />
                <div
                    className="px-8 py-12 relative"
                    style={{ backgroundSize:'cover', backgroundPosition:'center', backgroundImage: `url(${require('../../assets/bg-1.jpg')})` }}>
                    <div className="bg-gradient-black-to-transparent"></div>
                    <div className="text-center">
                        <h2 className="relative text-center text-2xl lg:text-4xl text-white font-bold">COME TOGETHER, SUPPORT ONE ANOTHER.</h2>
                        <p className="relative text-white text-lg lg:text-2xl text-center max-w-6xl mx-auto">Welcome to our Blog! Here at West, we are so fortunate to have incredible care support staff members that not only prioritize patients and their family members, they want to support associates as well! On this page, you will hear from our Chaplain, Nutritionist, and other members of our Care Support Team, sharing insights on peace and healing of the mind, body and soul.</p>
                        {pageState === 'normal' &&
                            <button
                                className="font-bold relative mt-8 p-4 bg-west-green hover:bg-west-green-400 hover:bg-west-green-400 items-center text-white leading-none rounded-full inline-flex"
                                onClick={() => this.setState({ pageState: 'new' })}>New post</button>
                        }
                    </div>
                </div>
                <div className="min-h-screen bg-gray-200 p-4">
                    {pageState === 'normal' && Boolean(posts) &&
                        <div>
                            <div className="w-full flex flex-wrap">
                                {posts.map(post => (
                                    <Card
                                        {...this.props}
                                        key={post._id}
                                        removePostLike={() => this.props.removePostLike(post._id, this._getPostLike(post.likes))}
                                        likePost={() => this.props.likePost(post._id)}
                                        iLike={() => this._hasLikedPost(post.likes)}
                                        post={post} />
                                ))}
                            </div>
                        </div>
                    }
                    {pageState === 'new' &&
                        <div className="max-w-3xl mx-auto">
                            <div className="max-w-xs mx-auto mb-8">
                                {Boolean(featureImgUrl) ?
                                    <img src={featureImgUrl} alt=""/>
                                    :
                                    <ImageUploader
                                        beginUpload={() => this.setState({ uploadInProgress: true })}
                                        updateFeatureImg={url => this.updateFeatureImg(url)} {...this.props} />
                                }
                            </div>
                            <label className="block font-semibold text-gray-700" htmlFor="title">Post title</label>
                            <input
                                className="mt-2 bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal"
                                type="text"
                                placeholder="Post title"
                                onChange={e => this.setState({ title: e.target.value })}/>
                            <label className="mt-6 block font-semibold text-gray-700" htmlFor="title">Post content</label>
                            <Editor
                                defaultEditorState={content}
                                toolbarClassName="mt-2 bg-transparent"
                                wrapperClassName="wrapperClassName"
                                editorClassName="mt-2 bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal"
                                onEditorStateChange={editorState => this.onEditorStateChange(editorState)} />
                            <button
                                className="p-4 text-gray-700 bg-transparent items-center text-white leading-none lg:rounded-full flex lg:inline-flex"
                                onClick={() => this.setState({ pageState: 'normal' })}>Cancel</button>
                            <button
                                disabled={uploadInProgress}
                                className={`mt-4 p-4 ${uploadInProgress ? 'bg-gray-600 cursor-not-allowed' : 'bg-west-green hover:bg-west-green-400'} items-center text-white leading-none lg:rounded-full flex lg:inline-flex`}
                                onClick={() => this.handleSubmit()}>{uploadInProgress ? 'Upload in progress..' : 'Submit post'}</button>
                        </div>
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/posts/index.js